import { fabric } from "fabric";

export default {
  addTextForKids,
  handleTextForKids,
};

function addTextForKids(
  canvas: fabric.Canvas,
  quote: string,
  color: string,
  width: number,
  height: number
) {
  let objects = canvas.getObjects("textbox");

  if (!objects.length) {
    canvas.add(
      new fabric.Textbox(quote, {
        // @ts-ignore
        id: "text-4",
        fill: color,
        fontFamily: "Calibri",
        fontSize:
          window.innerWidth < 360
            ? 8
            : window.innerWidth < 450
            ? 10
            : window.innerWidth < 768
            ? 14
            : 20,
        lockScalingFlip: true,
        lockScalingX: true,
        lockUniScaling: true,
        lockSkewingX: true,
        lockMovementX: true,
        lockMovementY: true,
        selectable: false,
        editable: false,
        originX: "center",
        originY: "center",
        textAlign: "center",
        width: width / 3,
        height: height / 3,
        left: (width / 3) * 1.5,
        top: (height / 3) * 1.5,
      })
    );
  }
}

function handleTextForKids(
  canvas: fabric.Canvas,
  quote: string,
  color: string
) {
  let canvasWidth = canvas.getWidth();
  let canvasHeight = canvas.getHeight();

  canvas.getObjects("textbox").forEach(function(object: fabric.Text) {
    object.set({
      text: quote,
      fill: color,
      width: canvasWidth / 3,
      height: canvasHeight / 3,
      left: canvasWidth / 2,
      top: canvasHeight / 2,
    });
  });
  canvas.renderAll();
}
